{
    "settings_title": "إعدادات النظام",
    "branding_title": "الهوية البصرية",
    "branding_description": "الألوان والشعارات والصور المستخدمة في التطبيق والبريد والتذاكر المطبوعة وتقارير PDF.",
    "branding_colours": "الألوان",
    "branding_assets": "الشعارات والصور",
    "branding_preview": "معاينة",
    "branding_upload_hint": "اسحب ملفاً هنا أو انقر للاختيار.",
    "branding_remove_asset": "إزالة هذا الملف",
    "branding_contrast_ok": "التباين يستوفي معيار WCAG AA.",
    "branding_contrast_warning": "التباين أقل من معيار WCAG AA لنص المحتوى. يُفضّل اختيار لون أغمق.",
    "users_title": "المستخدمون",
    "users_description": "حسابات الموظفين والأدوار ونطاق البيانات.",
    "users_new": "مستخدم جديد",
    "users_edit": "تعديل المستخدم",
    "users_never_signed_in": "لم يسجّل الدخول مطلقاً",
    "users_last_login": "آخر دخول",
    "users_scope": "نطاق البيانات",
    "users_roles": "الأدوار",
    "users_status": "الحالة",
    "users_suspend": "إيقاف الحساب",
    "users_activate": "تنشيط الحساب",
    "users_terminate_sessions": "تسجيل الخروج من جميع الأجهزة",
    "users_effective_permissions": "الصلاحيات الفعلية",
    "users_permission_via": "ممنوحة عبر {{roles}}",
    "users_permission_direct": "ممنوحة مباشرةً",
    "users_suspend_reason": "ما سبب إيقاف هذا الحساب؟",
    "roles_title": "الأدوار والصلاحيات",
    "roles_description": "ما يمكن لكل دور القيام به. يُضبط نطاق البيانات لكل مستخدم على حدة.",
    "roles_matrix": "مصفوفة الصلاحيات",
    "roles_clone": "نسخ الدور",
    "roles_users_count_zero": "لا يوجد مستخدمون",
    "roles_users_count_one": "مستخدم واحد",
    "roles_users_count_two": "مستخدمان",
    "roles_users_count_few": "{{count}} مستخدمين",
    "roles_users_count_many": "{{count}} مستخدماً",
    "roles_users_count_other": "{{count}} مستخدم",
    "roles_system": "دور أساسي",
    "roles_locked_hint": "لا يمكن تعديل هذا الدور.",
    "audit_title": "سجل التدقيق",
    "audit_description": "سجل تراكمي مرتبط بسلسلة تجزئة لكل تغيير. لا يمكن تعديل السجلات أو حذفها.",
    "audit_verify": "التحقق من السلامة",
    "audit_verifying": "جارٍ التحقق…",
    "audit_intact": "تم التحقق من السلامة — {{count}} سجلاً.",
    "audit_compromised": "فشل التحقق. تم تعديل السجل من خارج التطبيق.",
    "audit_event": "الحدث",
    "audit_actor": "نُفّذ بواسطة",
    "audit_entity": "السجل",
    "audit_changes": "التغييرات",
    "audit_before": "قبل",
    "audit_after": "بعد",
    "audit_reason": "السبب",
    "audit_no_changes": "لم تُسجّل تغييرات على الحقول.",
    "audit_auth_events": "نشاط تسجيل الدخول",
    "audit_sensitive": "الوصول إلى البيانات الحساسة",
    "audit_hash": "بصمة السجل",
    "health_title": "حالة النظام",
    "health_ok": "سليم",
    "health_warning": "يحتاج متابعة",
    "health_error": "متعطّل",
    "health_last_checked": "تم الفحص {{time}}",
    "health_database": "قاعدة البيانات",
    "health_queue": "معالجات الطوابير",
    "health_scheduler": "المجدول",
    "health_storage": "تخزين الملفات",
    "health_audit_trail": "سجل التدقيق",
    "layouts": {
        "title": "تخطيطات الشاشات",
        "description": "أي اللوحات تظهر، وبأي ترتيب، حسب شريحة العميل ودور الموظف.",
        "presentation_note": "التخطيطات تحدد الإبراز لا الصلاحية. إخفاء لوحة لا يقيّد أحداً — فما يحق للمستخدم الاطلاع عليه يحدده دوره ونطاق بياناته، ويُطبَّق على الخادم.",
        "empty_title": "لا توجد تخطيطات مُعدّة",
        "empty_description": "تعود كل شاشة إلى تخطيطها الافتراضي المبيّن أدناه.",
        "any_segment": "أي شريحة",
        "any_role": "أي دور",
        "specificity": "درجة التحديد {{score}}",
        "hide_panel": "إخفاء هذه اللوحة",
        "show_panel": "إظهار هذه اللوحة",
        "remove": "حذف التخطيط",
        "saved": "تم حفظ تخطيط الشاشة.",
        "removed": "تم حذف تخطيط الشاشة.",
        "defaults_title": "الإعدادات الافتراضية",
        "defaults_note": "تُستخدم عند عدم تطابق أي تخطيط. لا يمكن حذفها، وهذا ما يضمن ظهور كل شاشة حتى لو كان هذا الجدول فارغاً."
    }
}
